import * as i0 from "@angular/core";
/**
 * Class DictStorateService.
 *
 * Simple class to storoage data by keys (a dictionary).
 *
 */
export class DictStorageService {
    constructor() {
        this.storage = {};
        // Debug.
        window['rbstore'] = this;
    }
    put(key, data) {
        this.storage[key] = data;
    }
    get(key) {
        return this.storage[key];
    }
    keyExists(key) {
        return typeof this.storage[key] !== 'undefined';
    }
    remove(key) {
        delete this.storage[key];
    }
    count() {
        return Object.keys(this.storage).length;
    }
    putLang(lang) {
        localStorage.setItem('lang', JSON.stringify(lang));
    }
    getLang() {
        if (localStorage.getItem('lang') == null) {
            this.putLang({});
        }
        return JSON.parse(localStorage.getItem('lang'));
    }
    setLangs(lang) {
        this.put('langs', lang);
    }
    getLangs() {
        return this.get('langs');
    }
}
DictStorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DictStorageService_Factory() { return new DictStorageService(); }, token: DictStorageService, providedIn: "root" });
